import axios from 'axios'
import { createApp } from 'vue'
import FInputPassword from '~/js/components/inputPassword'
const ID_CUSTOMERS_LOGIN = 'js-customers-login'
import { isApp } from '~/js/helpers/user-agent-helper'
import { isDesktop } from '~/js/templates/index/helpers'
import { Customer } from '~/js/models/customer'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'

document.addEventListener('DOMContentLoaded', () => {
  const elementCustomersLogin = document.getElementById(ID_CUSTOMERS_LOGIN)
  if (!elementCustomersLogin) return

  createApp({
    name: 'TemplatesCustomersLogin',
    data() {
      return {
        email: '',
        errorMessage: '',
        isApp: isApp(),
        isProcessing: false,
        showRecoverForm: false,
        password: '',
      }
    },
    mounted() {
      this.showRecoverForm = window.location.hash.includes('recover')
      if (isDesktop()) {
        const heightContainer = this.$refs.container.clientHeight
        this.$refs.container.style.height = `${heightContainer}px`
      }
    },
    components: {
      FInputPassword,
    },
    methods: {
      async onSubmit($event) {
        if (this.isProcessing) return
        this.errorMessage = Customer.getEmailError(this.email)
        if (this.errorMessage) return
        this.isProcessing = true
        try {
          const response = await axios.post(
            `${baseUrlFrontApi}/customers/check_registered_email`,
            {
              emailAddress: this.email,
            }
          )
          if (!response.data.registered) {
            this.errorMessage =
              '未登録のアドレスです。入力されたメールアドレスに誤りがないかご確認ください。'
            this.isProcessing = false
            return
          }
          $event.target.form.submit()
        } catch (error) {
          console.error(error)
          this.isProcessing = false
        }
      },
    },
  }).mount(elementCustomersLogin)
})
